import React from 'react';
import PropTypes from 'prop-types';
import { useDisclosure } from 'hooks/useDisclosure';
import { Drawer } from '../Elements/Drawer';
import { Button } from '../Elements/Button';

/**
 * FormDrawer: triggerButton (element) opens drawer, it will clone triggerButton with onClick
 */
export const FormDrawer = ({
  title,
  children,
  isDone,
  triggerButton,
  submitButton,
  size = 'md',
}) => {
  const { open, close, isOpen } = useDisclosure();

  React.useEffect(() => {
    if (isDone) close();
  }, [isDone, close]);

  return (
    <>
      {React.cloneElement(triggerButton, { onClick: open })}
      <Drawer
        title={title}
        isOpen={isOpen}
        onClose={close}
        size={size}
        renderFooter={() => (
          <>
            <Button variant="outline" size="sm" onClick={close} className="mr-2">
              Cancel
            </Button>
            {submitButton}
          </>
        )}
      >
        {children}
      </Drawer>
    </>
  );
};

FormDrawer.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isDone: PropTypes.bool,
  triggerButton: PropTypes.node.isRequired,
  submitButton: PropTypes.node,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', 'full']),
};
